class ProductVideo extends HTMLElement {
  constructor() {
    super();

    this.videoContainerId = 'product-video-player';
    this.resourcesLoaded = false; // 资源是否已加载
    this.mediaElements = this.querySelector(`#${this.videoContainerId}`), // 视频容器
    this.videoId = this.mediaElements?.getAttribute('data-videoid'); // 视频 ID
    this.videoWidth = parseInt(this.mediaElements?.getAttribute('data-width')) || 800; // 视频 Width
    this.videoHeight = parseInt(this.mediaElements?.getAttribute('data-height')) || 450;  // 视频 Height
  }

  connectedCallback() {
    // 元素被添加到DOM时调用
    // 监听section进入视口初始化
    window.addEventListener('DOMContentLoaded', () => {
      this.observeElement(this, this.init.bind(this));
    });
  }

  // 创建一个 IntersectionObserver 实例
  observeElement(element, callback) {
    // 如果已经在视口内,立即执行回调
    if (this.isElementInViewport(element)) {
      callback();
      return;
    }
    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback();
          // 只执行一次，停止观察
          observerInstance.unobserve(entry.target);
        }
      });
    }, {
      // 视口外 1/2 高度以内触发
      root: null,
      threshold: 0.5
    });
    observer.observe(element);
  }
  // 判断元素是否在视口内
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= -el.offsetHeight / 2 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight / 2
    );
  }

  // 加载资源
  async loadResources() {
    if (this.resourcesLoaded) return true;

    try {
      // 动态加载 YouTube API
      const tag = document.createElement('script');
      tag.src = this.getAttribute('data-js-src');
      document.body.appendChild(tag);

      this.resourcesLoaded = true;
      return true;
    } catch (error) {
      return false;
    }
  }

  // Init Event
  init() {
    // 进入视口后加载资源
    if (!this.resourcesLoaded) {
      this.loadResources().then(success => {
        if (success) {this.initVideo();}
      });
    }
  }

  // 初始化视频相关弹窗
  initVideo() {
    // 定义全局函数
    window.onYouTubeIframeAPIReady = () => {
      window.pv_player = new YT.Player(this.videoContainerId, {
        width: parseInt(this.videoWidth) || 1200,
        height: parseInt(this.videoHeight) || 400,
        videoId: this.videoId,
        playerVars: {
          color: 'white',
          controls:1,
          rel:0,
          playlist: this.videoId
        },
        events: {
          'onReady': onPlayerReady,
        }
      });
    };
    window.onPlayerReady = () => {
      setInterval(() => {
        let cur_sec = window.pv_player.getCurrentTime();
        let total_sec = window.pv_player.getDuration();
        if(total_sec - cur_sec <= 2){
          window.pv_player.seekTo(0);
        }
      },500);
    }
  }
}

customElements.define('product-video', ProductVideo);
